import { FieldGroup } from "~/components/form/FieldGroup";
import { YesNo } from "~/components/form/radio/YesNo";
import { QldSurveyData } from "~/entities/survey/QldSurveyData";
import type { DataProperty } from "~/util/data";

export type QldSurveyProps = {
    value?: QldSurveyData | null;
    setPayload: (payload: QldSurveyData) => void;
    disabled?: boolean;
};

export const QldSurvey = ({ value, setPayload, disabled }: QldSurveyProps) => {
    const current = value ?? new QldSurveyData();

    const updateValue = <K extends DataProperty<QldSurveyData>>(field: K, value: QldSurveyData[K]) => {
        const payload = QldSurveyData.from(current);

        payload[field] = value;

        if (payload.dirty(field)) {
            setPayload(payload);
        }
    };

    return (
        <FieldGroup>
            <YesNo
                title="Do you live in Queensland?"
                name="in_queensland"
                value={current.in_queensland}
                onValueChange={(value: boolean) => updateValue("in_queensland", value)}
                disabled={disabled}
            />
        </FieldGroup>
    );
};
